"use strict";angular.module("app",["ui.router","ngAnimate","pascalprecht.translate","ngSanitize","angular-google-analytics","headroom","smoothScroll"]);